/**
 * @author Fernando Ruano
 * @component AuthRoute
 * @description Checks user in local storage and redirects accordingly.
 */

// Dependencies
import { useOktaAuth, SecureRoute } from '@okta/okta-react';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function AuthRoute(props) {
  const { authState } = useOktaAuth();
  const lastAuthPath = localStorage.getItem('lastAuthPath');

  if (lastAuthPath === '/loginStaff') {
    if (!authState?.isAuthenticated) {
      return <Redirect to="/loginStaff" />;
    }
    return <SecureRoute {...props} />;
  }

  if (!localStorage.getItem('user')) {
    if (lastAuthPath === '/loginStaff') {
      return <Redirect to="/loginStaff" />;
    }
    return <Redirect to="/" />;
  }
  return <Route {...props} />;
}

export default AuthRoute;
